import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { prefetchRoute } from '../../utils/routePreload';

// PrefetchLink — 跟 <Link> 行為完全相同，但會在 hover / focus / touchstart 時提早觸發
// 對應路由的 chunk 下載，讓真正 click 切過去時 chunk 已經在 cache 裡。
const PrefetchLink = ({ to, onMouseEnter, onFocus, onTouchStart, ...rest }) => {
  const handlePrefetch = useCallback(() => {
    if (typeof to === 'string') prefetchRoute(to);
  }, [to]);

  const handleMouseEnter = useCallback((e) => {
    handlePrefetch();
    if (onMouseEnter) onMouseEnter(e);
  }, [handlePrefetch, onMouseEnter]);

  const handleFocus = useCallback((e) => {
    handlePrefetch();
    if (onFocus) onFocus(e);
  }, [handlePrefetch, onFocus]);

  const handleTouchStart = useCallback((e) => {
    handlePrefetch();
    if (onTouchStart) onTouchStart(e);
  }, [handlePrefetch, onTouchStart]);

  return (
    <Link
      to={to}
      onMouseEnter={handleMouseEnter}
      onFocus={handleFocus}
      onTouchStart={handleTouchStart}
      {...rest}
    />
  );
};

export default PrefetchLink;
